import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MessageSquareIcon, GraduationCapIcon, HeartHandshakeIcon, BriefcaseIcon, ArrowRightIcon } from 'lucide-react';
import { Container } from '../../ui/Container';
import { Button } from '../../ui/Button';
const options = [{
  role: 'General Inquiry',
  desc: 'Questions about programs, organization or partnerships',
  icon: MessageSquareIcon,
  to: '/en/contact#general-inquiry'
}, {
  role: 'Become A Teacher',
  desc: 'Share your expertise with our learners',
  icon: GraduationCapIcon,
  to: '/en/contact#become-a-teacher'
}, {
  role: 'Volunteers',
  desc: 'Give your time to support families',
  icon: HeartHandshakeIcon,
  to: '/en/contact#volunteers'
}, {
  role: 'Careers',
  desc: 'Join our team and grow with us successfully',
  icon: BriefcaseIcon,
  to: '/en/contact#careers'
}];
export function GetInTouch() {
  return <section className="relative py-20 md:py-28 bg-white/60" data-id="element-623" data-mp="w6ml0u9m5gpr">
      <Container data-id="element-624" data-mp="w63cu59rm6ox">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12" data-id="element-625" data-mp="w4ihwejjglqj">
          <div data-id="element-626" data-mp="r5yvye4y39y6">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white text-sand-500 text-[11px] font-semibold tracking-[0.14em] uppercase border border-sand-300/50" data-id="element-627" data-mp="n5y67xcebcbt">
              Contact
            </span>
            <h2 className="font-display text-3xl md:text-5xl text-ink-900 leading-tight mt-4" data-id="element-628" data-mp="d925wewnhwic">
              Get In Touch
            </h2>
          </div>
          <Link to="/en/contact" data-id="element-629" data-mp="8fh8op2vt6k7">
            <Button variant="primary" data-id="element-630" data-mp="3hfou1xmt37o">Contact Us</Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-631" data-mp="3vmjipo48knjo">
          {options.map((opt, i) => <motion.a key={opt.role} href={opt.to} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} whileHover={{
          y: -4
        }} className="group flex flex-col justify-between gap-8 rounded-2xl bg-white border border-sand-300/50 p-6 shadow-soft hover:shadow-card transition-shadow" data-id="element-632" data-mp="3qllqsjtfcf4z" data-mpi={i}>
              <span className="w-12 h-12 inline-flex items-center justify-center rounded-full bg-sage-100 text-forest-700" data-id="element-633" data-mp="3l1fw37miqonh">
                <opt.icon size={22} strokeWidth={1.6} data-id="element-634" data-mp="3pyoen9bkwup9" />
              </span>
              <div data-id="element-635" data-mp="hjnyndpm5chw">
                <h3 className="font-display text-lg text-ink-900" data-id="element-636" data-mp="hje3zctmih5v">
                  {opt.role}
                </h3>
                <p className="mt-1.5 text-sm text-ink-500 leading-relaxed" data-id="element-637" data-mp="mch3e1l30ktz">
                  {opt.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-forest-700" data-id="element-638" data-mp="26yylxboedv82">
                  Get in touch
                  <ArrowRightIcon size={15} strokeWidth={2} className="transition-transform group-hover:translate-x-0.5" data-id="element-639" data-mp="2gre5gdfcerv2" />
                </span>
              </div>
            </motion.a>)}
        </div>
      </Container>
    </section>;
}